import type { ColorFamily, PublicProductSort } from '@repo/api-contracts';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api';

export const STORE_PAGE_SIZE = 20;

export interface StoreProductsParams {
  readonly categoryId?: string | undefined;
  /** 기획전 카드에서 들어온 목록 — 그 기획전에 묶인 공개 상품만 남긴다. */
  readonly exhibitionId?: string | undefined;
  readonly minOrderQtyMax?: number | undefined;
  readonly unitPriceMin?: number | undefined;
  readonly unitPriceMax?: number | undefined;
  readonly colorFamilies?: readonly ColorFamily[] | undefined;
  readonly sort: PublicProductSort;
  readonly page: number;
}

/** 스토어 공개 상품 목록(products.list) — 번호형 페이지네이션 쿼리. */
export const useStoreProductsQuery = (params: StoreProductsParams) =>
  trpc.products.list.useQuery(
    {
      page: params.page,
      limit: STORE_PAGE_SIZE,
      sort: params.sort,
      ...(params.categoryId !== undefined ? { categoryId: params.categoryId } : {}),
      ...(params.exhibitionId !== undefined ? { exhibitionId: params.exhibitionId } : {}),
      ...(params.minOrderQtyMax !== undefined ? { minOrderQtyMax: params.minOrderQtyMax } : {}),
      ...(params.unitPriceMin !== undefined ? { unitPriceMin: params.unitPriceMin } : {}),
      ...(params.unitPriceMax !== undefined ? { unitPriceMax: params.unitPriceMax } : {}),
      ...(params.colorFamilies !== undefined && params.colorFamilies.length > 0
        ? { colorFamilies: [...params.colorFamilies] }
        : {}),
    },
    // 페이지 이동 중 직전 페이지를 유지한다 — 목록이 로딩 문구로 깜빡이지 않게.
    { placeholderData: keepPreviousData },
  );
